import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IBaseResponse, IListItem, IWorkflowStatus } from '@nkr/models/index';
import { WorkflowStatusActionType } from '@nkr/enums/index';
import { GridApi, CsvExportParams, GridReadyEvent, FirstDataRenderedEvent } from 'ag-grid-community';
import { Button, FormControl, ToggleButtonGroup, ToggleButton, Well, Popover, Glyphicon, OverlayTrigger, FormGroup, ControlLabel } from 'react-bootstrap';
import { AppActionCreators, IApplicationState, IAppState, DashCenterActionCreators } from '@nkr/store/index';
import { IStatusListResponse, IWorkflowStatusResponse, IDispositionListResponse } from '@nkr/store/donor-intake/actions';
import MobileView from './mobile-view';
import StatusDeleteModal from './status-delete-modal';
import MediaQuery from 'react-responsive';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import Grid from './grid';

const popoverRight = (
    <Popover id='popover-trigger-hover-focus' title='Needs Follow-Up Usage'>
        When the status needs follow-up, the entry will re-appear in your 'To-Do' when they are near or after their 'next follow-up date'.
    </Popover>
);

interface IProps {
    centerId: number
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    addWorkflowStatus: (centerId: number, name: string, disposition: number, followUp: boolean, isInEmr: boolean, isRuledOut: boolean, isILDA: boolean) => Promise<IWorkflowStatusResponse>,
    updateWorkflowStatus: (centerId: number, wfStatus: IWorkflowStatus) => Promise<IBaseResponse>,
    deleteWorkflowStatus: (centerId: number, wfStatusId: number) => Promise<IBaseResponse>,
    getStatusList: (centerId: number) => Promise<IStatusListResponse>,
    getDispositionList: (centerId: number) => Promise<IDispositionListResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IState {
    statusName: string,
    dispositionId: number,
    statusId: number,
    isInEmr: boolean,
    isRuledOut: boolean,
    isILDA: boolean,
    addFollowUp: boolean,
    actionType: number,
    sortOrder: number,
    statusList: IWorkflowStatus[],
    dispositionList: IListItem[],
    sortOrderList: any[],
    modal: {
        show: boolean,
        statusName: string,
        statusId: number,
        actionType: number,
        value: number
    },
    gridApi: GridApi
}

class StatusList extends React.Component<TProps, IState> {
    readonly state: IState = {
        statusName: '',
        dispositionId: 0,
        statusId: 0,
        actionType: 0,
        isInEmr: false,
        addFollowUp: false,
        isRuledOut: false,
        isILDA: false,
        sortOrder: 0,
        statusList: [],
        dispositionList: [],
        sortOrderList: [],
        modal: {
            statusName: '',
            show: false,
            statusId: 0,
            actionType: 0,
            value: 0
        },
        gridApi: null
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });

        e.api.sizeColumnsToFit();
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: false,
            fileName: `contacts-${moment().format('YYYY-MM-DD')}.csv`,
            columnKeys: ['Name', 'Email', 'Center', 'Role', 'Deleted'],
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }

    componentDidMount = () => {
        this.getData();
    }

    getCurrentSortOrderList = (statusList: IWorkflowStatus[]) => {
        let sortOrderList = [];

        for (var i = 1; i <= statusList.length; i++) {
            sortOrderList[i] = i;
        }

        return sortOrderList;
    }

    getData = () => {
        this.props.showLoading('Getting workflow data, one moment please...').then(() => {
            Promise.all([
                this.props.getStatusList(this.props.centerId),
                this.props.getDispositionList(this.props.centerId)
            ])
                .then(([statusListReponse, dispositionListResponse]) => {
                    var statusListSorted = statusListReponse.data.results.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)
                    var sortOrderList = this.getCurrentSortOrderList(statusListSorted);

                    this.setState({
                        statusList: statusListSorted,
                        dispositionList: dispositionListResponse.data.results,
                        sortOrderList: sortOrderList
                    }, () => {
                        this.props.hideLoading();
                    });
                }).catch(() => {
                    this.props.hideLoading();
                })
        }).catch(() => {
            this.props.hideLoading();
        });
    }

    handleInputChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'statusName') {
            this.setState({
                statusName: value
            });
        }

        if (name == 'dispositionId') {
            this.setState({
                dispositionId: parseInt(value)
            });
        }
    }

    handleFollowUpChange = (addFollowUp: boolean) => {
        this.setState({
            addFollowUp
        });
    }

    handleInEmrChange = (isInEmr: boolean) => {
        this.setState({
            isInEmr
        });
    }

    handleIsRuledOutChange = (isRuledOut: boolean) => {
        this.setState({
            isRuledOut
        });
    }

    handleIsILDAChange = (isILDA: boolean) => {
        this.setState({
            isILDA
        });
    }

    handleUpdateConfirmation = (actionType, statusId, value) => {
        let status = this.state.statusList.find(x => x.id == statusId);
        let statusName = status != null ? status.description : '';

        this.setState({
            modal: {
                statusId: statusId,
                statusName: statusName,
                show: true,
                actionType: actionType,
                value: value
            }
        });
    }

    handleStatusUpdate = (actionType: WorkflowStatusActionType) => {
        //update
        switch (actionType) {
            case WorkflowStatusActionType.DispositionUpdate:
                //update applicable Disposition 
                this.handleAssignedDispositionChange(this.state.modal.statusId, this.state.modal.value);
                break;
            case WorkflowStatusActionType.followUpUpdate:
                //update followUp
                this.handleRowFollowUpChange(this.state.modal.statusId, this.state.modal.value == 1 ? true : false);
                break;
            case WorkflowStatusActionType.isInEmrUpdate:
                //update isInEmr
                this.handleRowInEmrChange(this.state.modal.statusId, this.state.modal.value == 1 ? true : false)
                break;
            case WorkflowStatusActionType.isRuledOutUpdate:
                //update isRuledOut
                this.handleRowIsRuledOutChange(this.state.modal.statusId, this.state.modal.value == 1 ? true : false)
                break;
            case WorkflowStatusActionType.isILDAUpdate:
                //update isRuledOut
                this.handleRowIsILDAChange(this.state.modal.statusId, this.state.modal.value == 1 ? true : false)
                break;
            case WorkflowStatusActionType.sortOrderUpdate:
                //update sortOrder
                break;
            case WorkflowStatusActionType.Delete:
                //delete workflowStatus
                this.handleDeleteWorkflowStatus(this.state.modal.statusId)
                break;
        }

        this.setState({
            modal: {
                show: false,
                statusName: '',
                statusId: 0,
                actionType: 0,
                value: 0
            }
        });

    }

    handleDeleteWorkflowStatus = (statusId: number) => {
        let status = this.state.statusList.find(x => x.id == statusId);
        let statusName = status != null ? status.description : '';

        if (statusName.length > 0) {
            this.props.deleteWorkflowStatus(this.props.centerId, statusId).then(response => {
                if (response.data.success) {

                    var clonedStatusList = _.cloneDeep(this.state.statusList).reduce(function (result, status) {
                        if (status.id !== statusId) {
                            result.push(status);
                        }
                        return result;
                    }, []);

                    var sortOrderList = this.getCurrentSortOrderList(clonedStatusList);

                    var statusListSorted = clonedStatusList.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1)

                    let sortCnt = 1;
                    statusListSorted.map(item => {
                        item.sortOrder = sortCnt;
                        sortCnt++

                        return item;
                    });

                    this.setState({
                        statusList: clonedStatusList,
                        sortOrderList: sortOrderList
                    }, () => {
                        toast.success('Workflow status deleted successfully');
                    });
                }
            });
        }
    }

    handleModalClose = () => {
        this.setState({
            modal: {
                statusId: 0,
                statusName: '',
                show: false,
                actionType: -1,
                value: -1
            }
        });
    }

    handleRowInEmrChange = (statusId: number, inEmrVal: boolean) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);
        let wfStatusClone = _.cloneDeep(wfStatus);

        wfStatusClone.isInEmr = inEmrVal;

        this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(response => {
            if (response.data.success) {
                let clonedStatusList = _.cloneDeep(this.state.statusList).map(item => {
                    if (item.id == statusId) {
                        item.isInEmr = inEmrVal;
                    }

                    return item;
                });

                this.setState({
                    statusList: clonedStatusList
                }, () => {
                    toast.success('Additional Follow Up changed successfully');
                });
            }
        });
    }

    handleRowIsRuledOutChange = (statusId: number, isRuledOut: boolean) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);
        let wfStatusClone = _.cloneDeep(wfStatus);

        wfStatusClone.isRuledOut = isRuledOut;

        this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(response => {
            if (response.data.success) {
                let clonedStatusList = _.cloneDeep(this.state.statusList).map(item => {
                    if (item.id == statusId) {
                        item.isRuledOut = isRuledOut;
                    }

                    return item;
                });

                this.setState({
                    statusList: clonedStatusList
                }, () => {
                    toast.success('Is Ruled Out changed successfully');
                });
            }
        });
    }

    handleRowFollowUpChange = (statusId: number, followUpVal: boolean) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);
        let wfStatusClone = _.cloneDeep(wfStatus);

        wfStatusClone.addFollowUp = followUpVal;

        this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(response => {
            if (response.data.success) {
                let clonedStatusList = _.cloneDeep(this.state.statusList).map(item => {
                    if (item.id == statusId) {
                        item.addFollowUp = followUpVal;
                    }

                    return item;
                });

                this.setState({
                    statusList: clonedStatusList
                }, () => {
                    toast.success('Additional Follow Up changed successfully');
                });
            }
        });
    }

    handleRowIsILDAChange = (statusId: number, isILDA: boolean) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);
        let wfStatusClone = _.cloneDeep(wfStatus);

        wfStatusClone.isILDA = isILDA;

        this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(response => {
            if (response.data.success) {
                let clonedStatusList = _.cloneDeep(this.state.statusList).map(item => {
                    if (item.id == statusId) {
                        item.isILDA = isILDA;
                    }

                    return item;
                });

                this.setState({
                    statusList: clonedStatusList
                }, () => {
                    toast.success('Is ILDA changed successfully');
                });
            }
        });
    }

    addWorkflowStatus = (statusName: string, dispositionId: number, addFollowUp: boolean, isInEmr: boolean, isRuledOut: boolean, isILDA: boolean) => {
        //get workflowStatus input
        let message = 'Adding workflow status, one moment please...';

        //validate data
        if (statusName.length == 0) {
            toast.warn('Status Name is required.');
            return;
        }

        this.props.showLoading(message).then(() => {
            this.props.addWorkflowStatus(this.props.centerId, statusName, dispositionId, addFollowUp, isInEmr, isRuledOut, isILDA)
                .then(response => {
                    let workflowStatusList = _.cloneDeep(this.state.statusList);

                    workflowStatusList.push(response.data.results);

                    //get count of sortOrder
                    let sortOrderList = [];

                    for (var i = 1; i <= workflowStatusList.length; i++) {
                        sortOrderList[i] = i;
                    }

                    this.setState({
                        statusName: '',
                        dispositionId: 0,
                        addFollowUp: false,
                        isInEmr: false,
                        isRuledOut: false,
                        isILDA: false,
                        statusList: workflowStatusList,
                        sortOrderList: sortOrderList
                    }, () => {
                        this.props.hideLoading();
                        toast.success('Log entry added successfully');
                    });
                })
                .catch((error: AxiosError) => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleSortOrderChange = (statusId: number, sortOrderId: number) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);

        this.props.showLoading('Changing disposition, one moment please...').then(() => {
            //update disposition
            let wfStatusClone = _.cloneDeep(wfStatus);
            wfStatusClone.sortOrder = sortOrderId;

            this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(workflowResponse => {
                this.props.hideLoading();

                if (workflowResponse.data.success) {
                    this.props.getStatusList(this.props.centerId).then(statusResponse => {
                        // var statusListSorted = statusResponse.data.results.sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1);
                        var statusListSorted = _.orderBy(statusResponse.data.results, item => item.sortOrder);

                        this.setState({
                            statusList: statusListSorted
                        }, () => {
                            toast.success('Order changed successfully');
                        });

                    });
                }
            });
        });
    }

    handleAssignedDispositionChange = (statusId: number, disId: number) => {
        let wfStatus = this.state.statusList.find(x => x.id == statusId);

        this.props.showLoading('Changing disposition, one moment please...').then(() => {
            //update disposition
            let wfStatusClone = _.cloneDeep(wfStatus);
            wfStatusClone.associatedDisposition = disId;

            this.props.updateWorkflowStatus(this.props.centerId, wfStatusClone).then(response => {
                this.props.hideLoading();

                if (response.data.success) {
                    let statusList = _.cloneDeep(this.state.statusList).map(item => {
                        if (item.id == statusId) {
                            item.associatedDisposition = disId;
                        }

                        return item;
                    });

                    this.setState({
                        statusList: statusList
                    }, () => {
                        toast.success('Assigned disposition changed successfully');
                    });
                }
            });
        });
    }

    render = () => {
        return (
            <>           
                <MediaQuery minWidth={1190} >               
                    <div className='container-fluid'>
                        <div>
                            <div className='row' style={{ marginTop: 10, marginBottom: 15 }}>
                                <div className='col-xs-12 col-lg-12'>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                                        <h1 style={{ margin: 0 }}>DASH Workflow Status Configuration</h1>
                                    </div>
                                </div>
                            </div>

                            <Well>
                                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                    <div style={{ marginRight: 20 }}>
                                        <FormGroup style={{ marginBottom: 0 }}>
                                            <ControlLabel>Status Name</ControlLabel>
                                            <FormControl
                                                placeholder='Status Name...'
                                                name='statusName'
                                                value={this.state.statusName}
                                                onChange={this.handleInputChange}
                                            />
                                        </FormGroup>
                                    </div>

                                    <div style={{ marginRight: 20 }}>
                                        <FormGroup style={{ marginBottom: 0 }}>
                                            <ControlLabel>Disposition</ControlLabel>
                                            <FormControl
                                                componentClass='select'
                                                name='dispositionId'
                                                value={this.state.dispositionId}
                                                onChange={this.handleInputChange}
                                            >
                                                <option value={-1}>Select Disposition</option>
                                                {this.state.dispositionList.map((item, index) =>
                                                    <option key={'disposition-' + index} value={item.id}>{item.description}</option>
                                                )}
                                            </FormControl>
                                        </FormGroup>
                                    </div>

                                    <div style={{ marginRight: 20 }}>
                                        <FormGroup style={{ marginBottom: 0 }}>
                                            <ControlLabel>Needs Follow-Up{' '}<OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={popoverRight}><Glyphicon glyph='info-sign' /></OverlayTrigger></ControlLabel>
                                            <div>
                                                <ToggleButtonGroup type='radio' name='status' value={this.state.addFollowUp}>
                                                    <ToggleButton type='radio' value={1} className={this.state.addFollowUp ? 'btn-primary' : 'btn-default'} onClick={() => this.handleFollowUpChange(true)}>Yes</ToggleButton>
                                                    <ToggleButton type='radio' value={2} className={!this.state.addFollowUp ? 'btn-primary' : 'btn-default'} onClick={() => this.handleFollowUpChange(false)}>No</ToggleButton>
                                                </ToggleButtonGroup>
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div style={{ marginRight: 20 }}>
                                        <FormGroup style={{ marginBottom: 0 }}>
                                            <ControlLabel>Is in EMR</ControlLabel>
                                            <div>
                                                <ToggleButtonGroup type='radio' name='status' value={this.state.isInEmr}>
                                                    <ToggleButton type='radio' value={1} className={this.state.isInEmr ? 'btn-primary' : 'btn-default'} onClick={() => this.handleInEmrChange(true)}>Yes</ToggleButton>
                                                    <ToggleButton type='radio' value={2} className={!this.state.isInEmr ? 'btn-primary' : 'btn-default'} onClick={() => this.handleInEmrChange(false)}>No</ToggleButton>
                                                </ToggleButtonGroup>
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <div style={{ marginRight: 20 }}>
                                        <FormGroup style={{ marginBottom: 0 }}>
                                            <ControlLabel>Is Ruled Out</ControlLabel>
                                            <div>
                                                <ToggleButtonGroup type='radio' name='status' value={this.state.isRuledOut}>
                                                    <ToggleButton type='radio' value={1} className={this.state.isRuledOut ? 'btn-primary' : 'btn-default'} onClick={() => this.handleIsRuledOutChange(true)}>Yes</ToggleButton>
                                                    <ToggleButton type='radio' value={2} className={!this.state.isRuledOut ? 'btn-primary' : 'btn-default'} onClick={() => this.handleIsRuledOutChange(false)}>No</ToggleButton>
                                                </ToggleButtonGroup>
                                            </div>
                                        </FormGroup>
                                    </div>

                                    <Button bsStyle='primary' onClick={() => this.addWorkflowStatus(this.state.statusName, this.state.dispositionId, this.state.addFollowUp, this.state.isInEmr, this.state.isRuledOut, this.state.isILDA)}>
                                        Add Status
                                    </Button>
                                </div>
                            </Well>

                            <Grid
                                list={this.state.statusList}
                                dispositionList={this.state.dispositionList}
                                sortOrderList={this.state.sortOrderList}
                                onGridReady={this.onGridReady}
                                onUpdateConfirmation={this.handleUpdateConfirmation}
                                onSortOrderChange={this.handleSortOrderChange} />
                        </div>
                    </div>
                </MediaQuery >

                <MediaQuery maxWidth={1183}>
                    <MobileView
                        statusList={this.state.statusList}
                        dispositionList={this.state.dispositionList}
                        sortOrderList={this.state.sortOrderList}
                        handleUpdateConfirmation={this.handleUpdateConfirmation}
                        onSortOrderChange={this.handleSortOrderChange}
                        addStatus={this.addWorkflowStatus}
                    />
                </MediaQuery>

                <StatusDeleteModal
                    show={this.state.modal.show}
                    statusName={this.state.modal.statusName}
                    statusId={this.state.modal.statusId}
                    actionType={this.state.modal.actionType}
                    onUpdate={this.handleStatusUpdate}
                    onClose={this.handleModalClose}
                />
            </>
        );
    }

}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        addWorkflowStatus: (centerId, name, disposition, followUp, isInEmr, isRuledOut, isILDA) => {
            return dispatch(DashCenterActionCreators.addWorkflowStatus(centerId, name, disposition, followUp, isInEmr, isRuledOut, isILDA));
        },
        deleteWorkflowStatus: (centerId, wfStatusId) => {
            return dispatch(DashCenterActionCreators.deleteWorkflowStatus(centerId, wfStatusId));
        },
        updateWorkflowStatus: (centerId, workflowStatusId) => {
            return dispatch(DashCenterActionCreators.updateWorkflowStatus(centerId, workflowStatusId));
        },
        getStatusList: (centerId) => {
            return dispatch(DashCenterActionCreators.getWorkflowStatusList(centerId));
        },
        getDispositionList: (centerId) => {
            return dispatch(DashCenterActionCreators.getDispositionList(centerId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(StatusList);